module.exports = __webpack_public_path__ + "static/media/DSC_0161.976cce9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0161.jpg
// module id = 638
// module chunks = 0